import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setLaunchKeydatesAction } from "@oldDashboard/legacyActions/dashboardClient";

interface UseLaunchKeyDatesProps {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, sort: String, searching: boolean }
const UseLaunchKeyDates = (props:UseLaunchKeyDatesProps) => {
    const { affiliateSelected, launchSelected, timePeriodSelected, startDate, endDate, sort, searching} = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchLaunchesKeyDates(sort);
    }, [searching, launchSelected]);

    const fetchLaunchesKeyDates= async(sort: String) => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getLaunchKeyDates(affiliateSelected, launchSelected, timePeriodSelected, startDate, endDate,sort);
            if (response) {
                setLaunchKeydatesAction(response);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, fetchLaunchesKeyDates }
}

export default UseLaunchKeyDates